import { useEffect, useReducer } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function usePersistQueryParam<RootState, Actions>(
  id: string,
  reducerFn: React.Reducer<RootState, Actions>,
  initialState: RootState,
  stateToQueryParamConverter: (state: RootState) => string,
  initializer?: (initialState: RootState) => RootState,
): [RootState, React.Dispatch<Actions>] {
  const navigate = useNavigate();
  const init = initializer ?? ((initialState) => initialState);
  const [state, setState] = useReducer(reducerFn, initialState, init);
  const [search] = useSearchParams();
  useEffect(() => {
    let filterQueryArguments = stateToQueryParamConverter(state);

    // print not being part of filter state, must be added to the query string
    if (search.get("print") == "true") {
      filterQueryArguments += "&print=true";
    }

    navigate(
      {
        pathname: window.location.pathname,
        search: filterQueryArguments,
      },
      { replace: true },
    );
  }, [id, state]);

  return [state, setState];
}
